import { cn } from '@/src/lib/utils/command';
import { ErrorMessage } from '@hookform/error-message';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type Tinput = {
  name: string;
  defaultValue?: any;
  placeholder?: string;
  type?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
};

const Input: FC<Tinput> = ({
  name,
  label,
  defaultValue,
  placeholder,
  required,
  type,
  disabled,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={cn('my-2 w-full', disabled && 'pointer-events-none cursor-not-allowed')}>
      {label && (
        <label className="text-gray-250 mb-2 flex items-center gap-1 font-bold" htmlFor={name}>
          {label} <span>{required ? '*' : ''}</span>
        </label>
      )}

      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue || ''}
        render={({ field: { value, onChange } }) => (
          <input
            className={cn(
              'placeholder:text-primary/40 mb-1 w-full rounded-lg border border-[#E7E7E8] bg-white px-5 py-3',
              disabled && 'bg-slate-200',
            )}
            type={type ?? 'text'}
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
          />
        )}
      />
      <ErrorMessage
        render={({ message }) => <p className="text-sm text-red-500">{message}</p>}
        errors={errors}
        name={name}
      />
    </div>
  );
};

export default Input;
